// @flow
import {rootReducer} from 'app/reducers';
import {AuthApi} from 'modules/auth/services/auth-api';
import {TokenApi} from 'modules/auth/services/token-api';
import {CentrifugeService} from 'modules/centrifuge/services/centrifuge';
import {CentrifugeApi} from 'modules/centrifuge/services/centrifuge-api';
import {AuthToken} from 'modules/common/services/auth-token';
import {CommonApi} from 'modules/common/services/common-api';
import {HttpService} from 'modules/common/services/http';
import {IntlApi} from 'modules/common/services/intl-api';
import {DashboardApi} from 'modules/dashboard/services/dashboard-api';
import {ExampleApi} from 'modules/example/services/example-api';
import {LicenseApi} from 'modules/license/services/license-api';
import {SettingsApi} from 'modules/settings/services/settings-api';
import {TrainingModulesApi} from 'modules/trainingModules/services/training-modules-api';
import {UserApi} from 'modules/user/services/user-api';
import thunk from 'redux-thunk';
import type {TAppConfig} from 'types';
import {makeStore} from './make-store';

/**
 * Фабрика для создания сервисов
 * @param appConfig Конфиг приложения
 * @returns Сервисы
 */
function createServices(appConfig: TAppConfig) {
    const authToken = new AuthToken('auth-token');
    // const localhostHttp = new HttpService('/api', authToken);
    const http = new HttpService(appConfig.apiUrl, authToken);

    return {
        authApi: new AuthApi(http),
        centrifugeApi: new CentrifugeApi(http),
        centrifugeService: new CentrifugeService(),
        commonApi: new CommonApi(http),
        dashboardApi: new DashboardApi(http),
        dataLoader: new IntlApi(http),
        exampleApi: new ExampleApi(http),
        licenseApi: new LicenseApi(http),
        settingsApi: new SettingsApi(http),
        tokenApi: new TokenApi(authToken),
        trainingModulesApi: new TrainingModulesApi(http),
        userApi: new UserApi(http),
    };
}

export type TThunkExtraArgs = $Call<typeof createServices, TAppConfig>;

/**
 * Создает redux-store для приложения
 * @param appConfig Конфиг приложения
 * @returns redux-store
 */
export function createAppStore(appConfig: TAppConfig) {
    const extraArgs = createServices(appConfig);
    const store = makeStore({
        debug: 'production' !== process.env.NODE_ENV,
        middlewares: [thunk.withExtraArgument(extraArgs)],
        reducer: rootReducer,
    });

    if (module.hot) {
        module.hot.accept('app/reducers', () => store.replaceReducer(rootReducer));
    }

    return store;
}
